import Image from "next/image";
import { IoIosArrowForward } from "react-icons/io";
import { motion } from "framer-motion";
import { useLanguage } from "@/components/context/LanguageContext";
import Head from "next/head";

const About = () => {
    const { language } = useLanguage();
    return (
        <>
            <Head>
                <title>Profile | About Us</title>
                <meta name="description" content="Generated by create next app" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Head>
            <div className="my-22">
                <div className="relative w-full h-[300px]">
                    <Image
                        src="/gambar4.jpg"
                        alt="Group Photo"
                        fill
                        className=" object-cover object-center"
                    />
                    <div className="absolute top-1/2 left-0 transform -translate-y-1/2 space-y-6 px-4 bg-gradient-to-r bg-transparent from-white/85 via-[#f0fdf4]/65 to-white/1 w-[75%] h-[300px] p-4 ">
                        <div className="space-y-20 xl:ml-15 items-center justify-center xl:justify-start">
                            <div className="ml-15 flex items-center space-x-2">
                                <p className="text-sm text-gray-800">Home</p>
                                <IoIosArrowForward className="text-gray-800 text-xl" />
                                <p className="text-sm text-gray-800">Profile</p>
                                <IoIosArrowForward className="text-gray-800 text-xl" />
                                <p className="text-sm text-gray-800">About</p>
                            </div>
                            <motion.div className=""
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}>
                                <p className="text-3xl xl:text-4xl font-bold  bg-clip-text bg-gradient-to-r text-gray-700 ml-15">
                                    {language === "en" ? "About Us" : "Tentang Kami"}
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
                <div className="max-w-screen-xl mx-auto">
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-10 justify-center items-center">
                        {/* Left Text Section */}
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5}}
                            viewport={{ once: true, amount: 0.2 }}
                            className="space-y-4 px-4"
                        >
                            <div className="flex items-center">
                                <Image className="rounded-md" src="/ahp-logo.png" alt="logo" width={60} height={40} />
                                <div className="flex flex-col ml-3">
                                    <p className="font-semibold text-3xl text-gray-800 tracking-widest">AHP</p>
                                    <p className="font-light text-xl text-gray-800 tracking-widest">PT Aruna Hijau Power</p>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <p className="text-gray-800 text-justify text-md font-light leading-7">
                                    {language === "en"
                                        ? "PT Aruna Hijau Power (AHP), which is committed to the development of renewable energy through solar panels, is a joint venture between PT Aruna Cahaya Pratama (Aruna PV) and PT PLN Batam"
                                        : "PT Aruna Hijau Power (AHP) yang berkomitmen dalam pengembangan energiterbarukan melalui panel surya, merupakan perusahaan kerjasama antar PT Aruna Cahaya Pratama (Aruna PV) dan PT PLN Batam."}
                                </p>
                                <p className="text-gray-800 text-justify text-md font-light leading-7">
                                    {language === 'en' ? "Through AHP, a 100 MWp ground-mounted solar power plant (PLTS) project spread over an area of 80.63 hectares and divided into 5 (five) separate sectors, was built and developed in the Kota Bukit Indah (KBI) industrial area, Purwakarta, West Java."
                                        :
                                        "Melalui AHP, proyek Pembangkit Listrik Tenaga Surya (PLTS) ground-mounted berkapasitas 100 MWp yang terhampar di area seluas 80,63 hektar dan terbagi dalam 5 (lima) sektor terpisah, dibangun dan dikembangkan di kawasan industri Kota Bukit Indah (KBI), Purwakarta, Jawa Barat."}
                                </p>
                                <p className="text-gray-800 text-justify text-md font-light leading-7">
                                    {language === 'en' ?
                                        'All electricity generated is channeled to business and industrial activities in the KBI industrial area, through PT Tatajabar Sejahtera (TJS), as the license holder of the business area (Wilus) for the KBI area owned by PT Besland Pertiwi.'
                                        :
                                        'Seluruh energi listrik yang dihasilkan disalurkan untuk kegiatan bisnis dan industri dalam kawasan industri KBI, melalui PT Tatajabar Sejahtera (TJS), selaku pemegang ijin wilayah usaha (Wilus) untuk kawasan KBI yang dimiliki oleh PT Besland Pertiwi.'}
                                </p>
                            </div>
                        </motion.div>

                        {/* Right Image Section */}
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            viewport={{ once: true, amount: 0.2 }}
                            className="mt-5 xl:mt-0 flex xl:flex-col justify-center px-2"
                        >
                            <Image src="/tjs.jpg" alt="logo" width={700} height={700} />
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;
